<div class="autocomplete-container" (click)="onContainerClick($event)">
  <input 
    #inputElement
    type="text" 
    [value]="control.value || ''"
    (input)="onInput($event)"
    [placeholder]="placeholder"
    (focus)="onFocus()"
    (blur)="onBlur()"
    autocomplete="off">
  
  <div class="autocomplete-suggestions" *ngIf="showSuggestions && filteredSuggestions.length > 0">
    <div 
      class="suggestion-item"
      *ngFor="let suggestion of filteredSuggestions"
      (mousedown)="onSuggestionMouseDown($event)"
      (click)="selectSuggestion(suggestion)">
      {{ suggestion }}
    </div>
  </div>
</div>